module.exports = __webpack_public_path__ + "static/media/susan-yin-62145-unsplash.610abc19.jpg";